import React from 'react';
import PropTypes from 'prop-types';

import Picture from '@Theme/hellofinance/components/Picture/Picture';
import Icon from '@Theme/hellofinance/components/Icon/Icon';
import ArticleMeta from '@Theme/hellofinance/components/ArticleMeta/ArticleMeta';

import * as styles from './ArticleVerticalTile.module.scss';

const propTypes = {
  href: PropTypes.string,
  picture: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  heading: PropTypes.string,
  text: PropTypes.string,
  date: PropTypes.string,
  readingTime: PropTypes.string,
  datetime: PropTypes.string
};

const ArticleVerticalTile = ({
  href,
  picture,
  heading,
  text,
  date,
  datetime,
  readingTime
}) => {
  if (!href && !picture && !heading && !text && !date && !readingTime) {
    return false;
  }

  return <article className={styles.root}>
    {(picture && picture?.src) && <Picture
      xs={{ src: picture.src }}
      width={410}
      height={308}
      alt={picture?.alt}
      pictureClassname={styles.rootPicture}
      imgClassname={styles.rootImage}/>}
    {!picture?.src && <div
      className={`${styles.rootPicture} ${styles.rootPicturePlaceholder}`}>
      <Icon classname={styles.rootPictureIcon} name='placeholder' size={{
        width: 48,
        height: 48
      }}/>
    </div>}
    <div className={styles.rootContent}>
      {heading && <h2 className={styles.rootHeading}><a className={styles.rootLink} href={href}>{heading}</a></h2>}
      {text && <div className={styles.rootText}>{text}</div>}
      {(date && readingTime) && <ArticleMeta classname={styles.rootArticleMeta} datetime={datetime} date={date} readingTime={readingTime}/>}
    </div>
  </article>;
};

ArticleVerticalTile.propTypes = propTypes;

export default ArticleVerticalTile;
